export enum StatEventType {
  Login = 'LOGIN',
  ActionStepCompleted = 'ACTION_STEP_COMPLETED',
  GoalCompleted = 'GOAL_COMPLETED',
}
